import { Pipe, PipeTransform } from '@angular/core';
import { Media } from '../models/page-components/media.model';

@Pipe({
  name: 'imageHeight',
  standalone: true,
})
export class ImageHeightPipe implements PipeTransform {
  // Calculate image height using the image ratio and the provided width or height
  transform(image: Media, imageWidth: number = 0, imageHeight: number = 0) {
    if (image.ImageRatio && imageWidth) {
      return Math.floor(imageWidth * image.ImageRatio);
    }
    return Math.floor(imageHeight / (image.ImageRatio ?? 1));
  }
}

@Pipe({
  name: 'imageWidth',
  standalone: true,
})
export class ImageWidthPipe implements PipeTransform {
  // Calculate image width using the image ratio and the provided width or height
  transform(image: Media, imageHeight: number = 0) {
    if (image.ImageRatio && imageHeight) {
      return Math.floor(imageHeight / image.ImageRatio);
    }
    return Math.floor(imageHeight / (image.ImageRatio ?? 1));
  }
}
